import React, {useEffect, useState} from 'react';
import {goToPage} from '../touristESimBlockSlice';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const InformationPage = (props) => {
  const formSubmmit = () => {
    props.goToPage('packagePage');
  };
  return (
    <div className='tabs-container'>
      <div className='title'>informationPage</div>
      <div className='title'>{props.packageName.value}</div>
      <div className='button-wrapper'>
        <BtnSubmit text='to: PackagePage' onclick={() => formSubmmit()} formid='InformationPage' />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    packageName: state.touristESimBlock.packageName,
    //other states
  };
};
const mapDispatchToProps = {
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(InformationPage);
